import React from 'react';
import { pressLogos, collectiveTiers } from '../mock';

export function AsSeenIn() {
  const items = pressLogos.concat(pressLogos);
  return (
    <section className="bg-white py-20 md:py-24 overflow-hidden">
      <div className="text-center mb-14">
        <h3
          className="text-3xl md:text-4xl text-[#1a1a1a]"
          style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
        >
          As Seen In
        </h3>
        <div className="h-px w-16 bg-[#b39869] mx-auto mt-4" />
      </div>
      <div className="relative">
        <div className="flex gap-16 md:gap-24 animate-marquee whitespace-nowrap items-center px-6">
          {items.map((l, i) => (
            <div key={`${l.name}-${i}`} className="shrink-0 flex items-center justify-center h-16 md:h-20 px-4 border-l border-r border-[#e5e0d5] first:border-l-0">
              <img
                src={l.src}
                alt={l.name}
                className="max-h-10 md:max-h-12 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CollectiveExperience() {
  return (
    <section id="launch" className="bg-white py-24 md:py-28 px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block mb-6 pb-1 border-b border-[#b39869]">
            <span className="tracking-[0.35em] text-[11px] text-[#b39869] uppercase">Services</span>
          </div>
          <h2
            className="text-4xl md:text-5xl mb-6 leading-tight text-[#1a1a1a]"
            style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
          >
            The Collective Experience
          </h2>
          <p className="text-[#555] text-sm md:text-base max-w-2xl mx-auto">
            A refined structure supporting advisors committed to excellence at every stage of their journey.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {collectiveTiers.map((t) => (
            <div key={t.id} id={t.id} className="group cursor-pointer">
              <div className="relative overflow-hidden aspect-[4/5] mb-6">
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                  style={{ backgroundImage: `url(${t.image})` }}
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition-colors duration-500" />
              </div>
              <h4
                className="text-2xl md:text-3xl text-[#1a1a1a] mb-3 text-center"
                style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
              >
                {t.title}
              </h4>
              <p className="text-[#555] text-sm leading-relaxed mb-5 text-center max-w-sm mx-auto">
                {t.description}
              </p>
              <div className="text-center">
                <span className="inline-block border-b border-[#b39869] pb-1 text-[11px] tracking-[0.35em] uppercase text-[#b39869] group-hover:translate-x-1 transition-transform duration-300">
                  Explore {t.title} →
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
